import { GET_USERS_CHECKTIME_SUCCESS } from "../constants/actionTypes.js";

const initialState = {};

const userHistoryTimelineReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_CHECKTIME_SUCCESS:
      return {
        ...state,
        userHistoryTimelineData: action.payload,
      };
    default:
      return state;
  }
};
export default userHistoryTimelineReducer;
